//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getaddlog } from '@/api/hgfw'
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.addLog()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  methods: {
    // 浏览量
    addLog () {
      getaddlog({
        accountid: this.accountid,
        moduleid: 1200,
        submoduleid: 120124
      })
    },
    linkindex () {
      this.$router.push({ name: 'yiliaohuzhu' })
    },
    linkcreate () {
      this.$router.push({ name: 'yiliaohuzhuCreate' })
    }
  }
}
